
import React, { useContext, useEffect, useState, useCallback } from "react";
import {
  DropdownOption,
  Dropdown,
  Button,
} from "@abb/abb-common-ux-react";
import axios from "axios";
import bedasgetTimestamps from "../../../util";
import { RootContext } from "../../../contexts/root-context";
import "./substation-explorer.css";
import { BEDAS_BASE_URL, ROUTE_PAGES } from "../../../strings";
import NotificationExample from "../../../components/cognien-components/Notification/notification";
import { getToken } from "../../../components/Authentication/get-token";
import "./substation-filters.css";
import { useLocation, useNavigate } from "react-router-dom";
import jsonSchema from './substation-filters.json';

// Import Form components for settings button
import Form from "@rjsf/core";
import validator from '@rjsf/validator-ajv8';

function SubstationFilters({ substationTitle }) {
  const navigate = useNavigate();
  const [selectedSingle, setSelectedSingle] = useState(localStorage.getItem('selectedTimeFilter'));
  const [loggedInUserInfo, setLoggedInUserInfo] = useState();
  
  const {
    setdrmetrics,
    setrelayMetrics,
    setselectedTimeTitle,
    bedasstartTS,
    bedassetstartTS,
    isnotify,
    setisnotify,
    bedasendTS,
    bedassetendTS,
    subIds,
    mapMarkerErrorMsg,
    setMetricsLoading,
    relay,
    drmetrics
  } = useContext(RootContext);
  const location = useLocation();
  const [_,setError] = useState(false);

  // Settings button schema (you can move this to a separate JSON file if needed)
  const settingsButtonSchema = {
    type: "object",
    properties: {
      settings: {
        name: "settings",
        isEnabled: true,
        type: "boolean",
        default: true,
        icon: "abb/settings",
        text: "Settings",
        shape: "pill",
        btn_type: "normal",
        size_class: "medium"
      }
    }
  };

  const settingsButtonUISchema = {
    settings: {
      style: {
        "background-color": null,
        "fontSize": null,
        "padding": null,
        "margin": "10px"
      }
    }
  };

  // Extract user info on component mount
  useEffect(() => {
    const extractUserDetailsFromLocalStorage = () => {
      const userDetails = JSON.parse(localStorage.getItem("USER_INFO"));
      setLoggedInUserInfo(userDetails);
    };
    extractUserDetailsFromLocalStorage();
  }, []);

  const checkAssignedSubstation = useCallback(() => {
    const getCurrentSubstaations = JSON.parse(localStorage.getItem('USER_INFO') || '{}');
    if (getCurrentSubstaations?.operationAreas?.length > 0 && getCurrentSubstaations?.operationAreas[0] === "") {
      setisnotify && setisnotify("no-sub-assign");
    }
  }, [setisnotify]);

  useEffect(() => {
    checkAssignedSubstation();
    fetchRelayMetrics();
    fetchDRMetrics();
  }, [checkAssignedSubstation, bedasstartTS, subIds]);

  useEffect(() => {
    console.log("Relay", relay);
    // Add null/undefined checks before checking length
    if (!relay || relay.length === 0 || !drmetrics || drmetrics.length === 0) {
        setMetricsLoading && setMetricsLoading(true);
    } else {
        setMetricsLoading && setMetricsLoading(false);
    }
  }, [relay, drmetrics, setMetricsLoading]);

  const fetchRelayMetrics = useCallback(async () => {
    const currentPage = location.pathname;
    const substationList = currentPage.includes("explorer")
    ? JSON.parse(localStorage.getItem('subIds') || '[]')
    : [localStorage.getItem('selectedSubstationId')];
    
    if (!substationList.length || substationList.includes('null') || substationList.includes(null)) {
      console.warn('No valid substation IDs found.');
      setrelayMetrics && setrelayMetrics([]);
      return;
    }
    
    const requestBody = { substationList };
    try {
      const response = await axios.post(
        `${BEDAS_BASE_URL}substation-metrics?startDateTime=${bedasstartTS}&endDateTime=${bedasendTS}`,
        requestBody,
        getToken()
      );
      setrelayMetrics(response.data);
      setError(false);
    } catch (error) {
      console.error('Error fetching relay metrics:', error);
      setError(true);
      setrelayMetrics && setrelayMetrics([]);
    }
  }, [bedasstartTS, bedasendTS, location.pathname, setrelayMetrics]);

  const fetchDRMetrics = useCallback(async () => {
    const substationList = JSON.parse(localStorage.getItem('subIds') || '[]');
    if (!substationList.length) {
      console.warn('No valid substation IDs found for DR metrics.');
      setdrmetrics && setdrmetrics([]);
      return;
    }
    
    const requestBody = { substationList };
    try {
      const response = await axios.post(
        `${BEDAS_BASE_URL}substation-dr-metrics?startDateTime=${bedasstartTS}&endDateTime=${bedasendTS}`,
        requestBody,
        getToken()
      );
      setdrmetrics(response.data);
      setError(false);
    } catch (error) {
      console.error('Error fetching DR metrics:', error);
      setError(true);
      setdrmetrics && setdrmetrics([]);
    }
  }, [bedasstartTS, bedasendTS, setdrmetrics]);

  const getFilterTime = useCallback((filterVal) => {
    // Add safety check for filterVal
    if (!filterVal || !Array.isArray(filterVal) || filterVal.length === 0 || !filterVal[0]) {
      console.warn('Invalid filter value received');
      return;
    }

    const label = String(filterVal[0].label);
    const { startDate, endDate } = bedasgetTimestamps(filterVal[0].value);
    
    // Handle the case when the time filter remains the same
    const filterInput = JSON.parse(localStorage.getItem("bedasfilterInput") || '{"title": "Last 24 hours"}');
    const title = filterInput ? filterInput.title : "Last 24 hours";
    
    if(label === title) return;
    
    // Clear the metrics when a new time filter is selected
    setdrmetrics && setdrmetrics([])
    setrelayMetrics && setrelayMetrics([])
    // Show Loading spinner while the metrics are being fetched
    setMetricsLoading && setMetricsLoading(true)
    setSelectedSingle(label);
    bedassetstartTS && bedassetstartTS(startDate);
    bedassetendTS && bedassetendTS(endDate);
    setselectedTimeTitle && setselectedTimeTitle(label);
    localStorage.setItem('selectedTimeFilter', label);
    localStorage.setItem("bedasfilterInput", JSON.stringify({ title: label, start: startDate, end: endDate }));
  }, [bedassetstartTS, bedassetendTS, setselectedTimeTitle, setdrmetrics, setrelayMetrics, setMetricsLoading]);

  const setOnRefresh = useCallback(() => {
    const filterInput = JSON.parse(localStorage.getItem("bedasfilterInput") || '{"title": "Last 24 hours"}');
    
    // Add safety check for jsonSchema
    if (!jsonSchema?.timePeriodDropdown?.options) {
      console.error('JSON schema or timePeriodDropdown options not available');
      return;
    }
    
    const timePeriod = jsonSchema.timePeriodDropdown.options.find(sub => sub.title === filterInput.title);
    
    if (!timePeriod) {
      console.warn('Time period not found in options');
      return;
    }
    
    const modifiedRefreshTimes = bedasgetTimestamps(timePeriod.value);
    bedassetstartTS && bedassetstartTS(modifiedRefreshTimes?.startDate);
    bedassetendTS && bedassetendTS(modifiedRefreshTimes?.endDate);
    localStorage.setItem("bedasfilterInput", JSON.stringify({ title: filterInput.title, start: bedasstartTS, end: bedasendTS }));
    window.location.reload();
  }, [bedassetstartTS, bedassetendTS, bedasstartTS, bedasendTS]);

  // Settings button click handler
  const openSettingsPage = () => {
    navigate(`../${ROUTE_PAGES.SETTINGS}`);
  };

  // Settings Button Widget component
  const SettingsButtonWidget = ({ schema, uiSchema }) => {
    return (
      <Button
        icon={schema.icon}
        text={schema.text}
        onClick={openSettingsPage}
        shape={schema.shape}
        type={schema.btn_type}
        sizeClass={schema.size_class}
        style={uiSchema.style}
      />
    );
  };

  // Add safety check for jsonSchema
  if (!jsonSchema) {
    console.error('JSON schema not loaded');
    return <div>Configuration not available</div>;
  }

  return (
    <>
    <div className="complete-filter CogniEn">
      <div className="col-5 col-m-12 col-s-12" style={{ padding: 0 }}>
        {(isnotify === "no-sub-assign" || isnotify === "unassigned-substation") && (
          <NotificationExample notitype={isnotify} />
        )}
        <div className="filter-header">
          {substationTitle?.enabled && substationTitle.label}
          &nbsp;
          {jsonSchema.lastRefreshLabel?.enabled && (
            <span className="last-updated">{jsonSchema.lastRefreshLabel.label}: {new Date().toLocaleString()}</span>
          )}
        </div>
      </div>
      <div className="col-7 col-m-12 col-s-12" style={{ padding: 0 }}>
        <span className="substation-waiting">{mapMarkerErrorMsg}</span>
        <div className="filters-group">
        {jsonSchema.timePeriodDropdown?.enabled && (
          <Dropdown
            className="filter-dropdown col-s-12"
            label={jsonSchema.timePeriodDropdown.label}
            placeholder={selectedSingle || "Last 24 Hours"}
            value={selectedSingle}
            onChange={getFilterTime}
          >
            {jsonSchema.timePeriodDropdown.options?.map((o) => (
              <DropdownOption key={o.title} label={o.title} value={o.value} />
            ))}
          </Dropdown>
        )}
        <div >
        {jsonSchema.refreshButton?.enabled && (
          <Button
           style={{ margin: "10px"}}
            sizeClass={"small"}
            icon="abb/synchronize"
            type="normal"
            shape={"rounded"}
            text={jsonSchema.refreshButton.label}
            onClick={setOnRefresh}
          />
        )} </div>
        {/* Settings Button - Only show for OperationalManager */}
        {loggedInUserInfo?.role === "OperationalManager" && settingsButtonSchema.properties.settings.isEnabled && (
          <Form 
            schema={settingsButtonSchema.properties.settings} 
            uiSchema={settingsButtonUISchema.settings}
            validator={validator} 
            widgets={{ CheckboxWidget: SettingsButtonWidget }}
            children={[]}
          />
        )}
        </div>
      </div>
      </div>
    </>
  );
}

export default React.memo(SubstationFilters);